import useAmplitudeIqosProps from './useAmplitudeIqosProps';
import useAmplitudeMarket from './useAmplitudeMarket';
import useAmplitudeOptOut from './useAmplitudeOptOut';
import useAmplitudeUserId from './useAmplitudeUserId';

const useAmplitudeInit = () => {
    useAmplitudeOptOut();
    useAmplitudeUserId();
    useAmplitudeIqosProps();
    useAmplitudeMarket();
};

export default useAmplitudeInit;
